import { SearchX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@/components/feedback/States'
import { Button } from '@/components/ui/Button'
import type { SiteContext } from '@/features/site/context'
import { APP_NAME } from '@/utils/brand'

/** A subdomain that belongs to no school. */
export function UnknownSitePage({ context }: { context: SiteContext | null }) {
  const { t } = useTranslation('site')
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-4">
      <EmptyState
        icon={<SearchX />}
        title={t('No school at this address')}
        description={t('Check the address your school gave you, or find your school on {{name}}.', {
          name: APP_NAME,
        })}
        action={
          context?.websiteUrl ? (
            <Button asChild>
              <a href={context.websiteUrl}>{t('Go to {{name}}', { name: APP_NAME })}</a>
            </Button>
          ) : undefined
        }
      />
    </div>
  )
}
